module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0048.jpg?v=044e4f5d";